// H:\PricingPenguin\PricingPenguinProj\pricing_penguin_frontend\src\middleware\GuestMiddleware.jsx

import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GuestMiddleware = () => {
  const { user, accessToken } = useAuth();
  const location = useLocation();

  const publicRoutes = [
    "/home",
    "/login",
    "/signup",
    "/signup/contractor",
    "/signup/homeowner",
    "/chat",
    "/project-summary",
    "/forgot-password",
    "/reset-password",
    "/verify-success",
    "/verify-failure",
    "/secure-account",
    "/secure-account-success",
    "/about",
    "/careers",
    "/sustainability",
    "/faqs",
    "/contact",
    "/support",
    "/blog",
    "/local-contractors",
    "/contractor-search",
    "/policies",
    "/disable-adblock",
    "/reviews",
    "/free-resources",
    "/learn-more",
    "/newsletter",
    "/trades-newsletter",
    "/penguin-admin-access",
    "/admin-password-setup",
    "/contractor-password-setup",
    "/signup-completion",
    "/upgrade-completion",
    "/cancel-completion",
    "/downgrade-completion",
    "/contractor-packages",
    "/contractor-quiz",
    "/unsubscribe",
    "/for-tradespeople",
    "/cost-guides",
    "/trade-advice",
    "/estimators",
    "/day-rates",
    "/warm-homes-plan",
    "/cost-calculator",
    "/widget-installation",
    "/quote-check",
    "/trusted-by-percy",
    "/trust-score",
    "/homeowner-trust",
    "/verify",
    "/your-home",
    "/apps",
    "/find-contractor",
    "/partners",
    "/payment-saved",
  ];

  const isPublicRoute =
    publicRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/verify-email/") ||
    location.pathname.startsWith("/verify/") ||
    location.pathname.startsWith("/newsletter/") ||
    location.pathname.startsWith("/chat/") ||
    location.pathname.startsWith("/blog/") ||
    location.pathname.startsWith("/contractor-search/") ||
    location.pathname.startsWith("/contractor/") ||
    location.pathname.startsWith("/cost-guides/") ||
    location.pathname.startsWith("/trade-advice/") ||
    location.pathname.startsWith("/estimators/") ||
    location.pathname.startsWith("/costs/") ||
    location.pathname.startsWith("/tradespeople/") ||
    location.pathname.startsWith("/reports/") ||
    location.pathname.startsWith("/add-payment/");


  if (accessToken) {
    if (location.pathname === "/login") {
      const redirectTo =
        user?.user_type === "contractor" ? "/contractor-home"
        : user?.user_type === "admin" || user?.user_type === "sales" ? "/admin/dashboard"
        : user?.user_type === "merchant" || user?.user_type === "partner" ? "/admin/merchant-dashboard"
        : "/home";
      return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }
    return <Outlet />;
  }
  else {
    if (isPublicRoute) {
      return <Outlet />;
    }
    else {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }
};

export default GuestMiddleware;